module.exports = __webpack_public_path__ + "static/media/testIcon.64f9b4d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testIcon.svg
// module id = 41
// module chunks = 0